const ListTable = require('app/ui/list/Table');
const ConfirmModal = require('app/ui/modal/Confirm');
const GraphQLMutation = require('app/graphql/Mutation');
const IFrame = require('app/ui/modal/IFrame');


const ExcelModal = require('app/billing/receipt/export/ExcelModal');

class IndexView {
    defaultOptions() {
        return {
            'selector': '.view-billing-receipt-list',
            'tableContainerSelector': '.billing-receipt-list-container',
            'filterFormSelector': '.billing-receipt-list-search-form',
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);

        this.buildGraphQLParameters = this.buildGraphQLParameters.bind(this);
        this.onSubmitFilterForm = this.onSubmitFilterForm.bind(this);
        this.onClickExport = this.onClickExport.bind(this);
        this.preprocessData = this.preprocessData.bind(this);

        this.$container = $(this.settings.selector);
        if(this.$container.length <= 0){
            window.notify("Can't find container view with selector " + this.settings.selector,'danger');
        }

        this.$tableContainer = $(this.settings.tableContainerSelector,this.$container);
        this.$filterForm =  $(this.settings.filterFormSelector,this.$container);
        this.$btnExport = $('.btn-billing-receipt-export');

        this.initialize();
    }

    initialize() {
        var self = this;

        this.initializeFilterForm();
        this.initializeListTable();
        this.bindEvents();
    }

    initializeFilterForm(){
        var self = this;

        this.$filterByDateFrom = $('input[name="dateFrom"]',this.$filterForm);
        this.$filterByDateFrom.on('change',this.onSubmitFilterForm);

        this.$filterByDateTo = $('input[name="dateTo"]',this.$filterForm);
        this.$filterByDateTo.on('change',this.onSubmitFilterForm);

        this.$filterForm.on('submit',this.onSubmitFilterForm);


    }

    onSubmitFilterForm(event){
        event.preventDefault()
        event.stopPropagation();

        this.table.refresh();
    }

    refresh(){
        this.$btnExport.attr('disabled','disabled');
        this.table.refresh();
    }


    initializeListTable(){
        var self = this;

        let fields = [
            'id',
            'reference',
            'date',
            'customerName',
            'ht',
            'ttc',
            'type',
            'avoir',
            'customer { id name email }'
        ];

        this.table = new ListTable({
            '$container': this.$tableContainer,
            'tableClass': 'table table-striped billing-receipt-list',
            'showPagination': false,
            'id': 'list-billing-receipts',
            'length': 10000,
            'graphQL': {
                'queryType': 'billingInvoices',
                'fields': fields,
                'parameters': this.buildGraphQLParameters,

            },
            'preprocessData': this.preprocessData,
            'columns': [
                {
                    'name': 'customer',
                    'label': window.translate('billing.receipt.customer.label'),
                    'class': 'billing-receipt-customer',
                    'render': function(item,index){
                        return item.node.customer.name;
                    },
                },
                {
                    'name': 'invoice',
                    'label': window.translate('billing.receipt.invoice.label'),
                    'class': 'billing-receipt-invoice',
                    'render': function(item,index){
                        return item.node.invoiceLabel;
                    },
                },
                {
                    'name': 'invoiceNumber',
                    'label': window.translate('billing.receipt.invoiceNumber.label'),
                    'class': 'billing-receipt-invoiceNumber',
                    'render': function(item,index){
                        let $content  = $('<ul/>')
                        .addClass('list-unstyled');

                        for(var i in item.node.invoices){
                            let invoice = item.node.invoices[i];
                            let $li = $('<li/>')
                            .append(invoice.reference);

                            if(invoice.avoir){
                                let value = parseFloat(invoice.ttc) * -1;
                                let title = window.formatFloat(value) + '€ TTC';
                                $li
                                .addClass('text-warning')
                                .attr('title',"Avoir de "+title)
                            }else{
                                let value = parseFloat(invoice.ttc);
                                let title = window.formatFloat(value) + '€ TTC';
                                $li
                                .attr('title',title)

                            }
                            if(!invoice.avoir){
                                $content.append($li);
                            }
                        }
                        return $content;
                    },
                },
                {
                    'name': 'date',
                    'label': window.translate('billing.receipt.date.label'),
                    'class': 'billing-receipt-date',
                    'render': function(item,index){

                        if(false){// comment with slash+star not working so i comment with if(false)
                            let $content  = $('<ul/>')
                            .addClass('list-unstyled');

                            for(var i in item.node.invoices){
                                let invoice = item.node.invoices[i];
                                let date = window.formatDate(invoice.date,window.translate('momentDateFormat.fullDay'));

                                if(!date){
                                    date = "non définie";
                                }

                                let $li = $('<li/>')
                                .append(date);

                                if(invoice.avoir){
                                    $li
                                    .addClass('text-warning')
                                    .attr('title',"Avoir "+invoice.reference)
                                }

                                if(invoice.date == item.node.date){
                                    $li.addClass('fw-bold');
                                }

                                $content.append($li);
                            }
                            return $content;
                        }

                        return window.formatDate(item.node.date,window.translate('momentDateFormat.fullDay'));
                    },
                },
                {
                    'name': 'ht',
                    'label': window.translate('billing.receipt.ht.label'),
                    'class': 'billing-receipt-ht',
                    'render': function(item,index){
                        return window.formatFloat(item.node.ht) + ' &euro;';
                    },
                },
                {
                    'name': 'ttc',
                    'label': window.translate('billing.receipt.ttc.label'),
                    'class': 'billing-receipt-ttc',
                    'render': function(item,index){
                        return window.formatFloat(item.node.ttc) + ' &euro;';
                    },
                },
            ]
        })
    }

    buildGraphQLParameters(){
        let filters = {
            'customerType': 'Restaurant',
            'restaurantExist': true,
        };

        if( this.$filterByDateFrom.val() && this.$filterByDateTo.val()){
            let from = this.$filterByDateFrom.val();
            let to = this.$filterByDateTo.val();

            filters.date = 'BETWEEN '+from+' '+to;
        }

        let orderBy = 'customerName';
        let dir = "ASC";

        let parameters = {
            'filter' : filters,

            'orderBy': orderBy,
            'dir': dir,
        };


        return parameters;
    }

    preprocessData(data){
        
        let receiptsObjects = {};

        for(var i in data.edges){
            let edge = data.edges[i];
            let invoice = edge.node;


            let customer = invoice.customer;

            if(receiptsObjects[customer.id] === undefined){
                receiptsObjects[customer.id] = {
                    'customer': customer,
                    'invoices': [],
                    'date': invoice.date,
                    'avoir': null,
                    'ttc': 0,
                    'ht': 0,
                };
            }

            receiptsObjects[customer.id]['invoices'].push(invoice);

            let currentDate = moment(invoice.date);
            let previousDate = moment(receiptsObjects[customer.id]['date']);
            if(previousDate < currentDate){
                receiptsObjects[customer.id]['date'] = invoice.date;
            }

            receiptsObjects[customer.id]['ht'] += parseFloat(invoice.ht);
            receiptsObjects[customer.id]['ttc'] += parseFloat(invoice.ttc);
            if(invoice.avoir){
                receiptsObjects[customer.id]['avoir'] = invoice.reference;
            }
        }

        let customerIds = Object.keys(receiptsObjects);
        let newData = {
            'totalCount': customerIds.length,
            'pageInfo': data.pageInfo,
            'edges': [],
        };

        let newEdges = [];
        for(var i in customerIds){
            let customerId = customerIds[i];
            let receipt = receiptsObjects[customerId];

            if(!receipt.avoir || receipt.invoices.length > 1){
                let label = "Du "+window.formatDate(this.$filterByDateFrom.val(),window.translate('momentDateFormat.fullDay'));
                label += ' au '+window.formatDate(this.$filterByDateTo.val(),window.translate('momentDateFormat.fullDay'));

                if(receipt.avoir){
                    label += '<div class="text-warning">Avoir '+receipt.avoir+"</div>";
                }

                receipt.invoiceLabel = label;

                newEdges.push({
                    'node': receipt
                });
            }
        }

        //sort by customer.name has previous loop might have break the sort order
        newEdges.sort(function(a,b){
            return a.node.customer.name.localeCompare(b.node.customer.name);
        });
        newData.edges = newEdges;

        if(customerIds.length > 0){
            this.$btnExport.removeAttr('disabled');
        }

        return newData;
    }

    bindEvents(){
        this.$btnExport.on('click',this.onClickExport)
    }

    onClickExport(event){
        event.preventDefault();
        event.stopPropagation();

        let modal = new ExcelModal({
            'parameters': this.buildGraphQLParameters(),
        });
    }

}

module.exports = IndexView;

